const photocode = `
    <?xml version="1.0" encoding="UTF-8"?>
    <svg width="20px" height="20px" viewBox="0 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <!-- Generator: Sketch 57.1 (83088) - https://sketch.com -->
        <title>qr-code</title>
        <desc>Created with Sketch.</desc>
        <g id="Photocode" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="DB-photocode---list" transform="translate(-322.000000, -249.000000)">
                <g id="Photos-Copy" transform="translate(284.000000, 211.000000)">
                    <g id="qr-code" transform="translate(39.000000, 39.000000)">
                        <g id="Outline_Icons" stroke="#ffffff" stroke-linecap="round" stroke-linejoin="round">
                            <g id="Group">
                                <rect id="Rectangle" x="0.37875" y="0.375" width="5.25" height="5.25"></rect>
                                <rect id="Rectangle" x="1.87875" y="1.875" width="2.25" height="2.25"></rect>
                                <rect id="Rectangle" x="0.37875" y="12.375" width="5.25" height="5.25"></rect>
                                <rect id="Rectangle" x="1.87875" y="13.875" width="2.25" height="2.25"></rect>
                                <rect id="Rectangle" x="12.37875" y="12.375" width="2.25" height="2.25"></rect>
                                <rect id="Rectangle" x="12.37875" y="0.375" width="5.25" height="5.25"></rect>
                                <rect id="Rectangle" x="13.87875" y="1.875" width="2.25" height="2.25"></rect>
                                <path d="M9.75375,7.125 L7.12875,7.125" id="Path"></path>
                                <polyline id="Path" points="7.12875 8.625 7.12875 10.875 9.75375 10.875"></polyline>
                                <polyline id="Path" points="0.37875 7.125 5.62875 7.125 5.62875 8.625"></polyline>
                                <polyline id="Path" points="16.875 10.875 16.875 7.125 17.62875 7.125"></polyline>
                                <path d="M15.375,8.625 L15.375,10.875" id="Path"></path>
                                <polyline id="Path" points="15.00375 7.125 11.625 7.125 11.625 8.625"></polyline>
                                <polyline id="Path" points="9.37875 3.375 9.37875 4.875 10.87875 4.875 10.87875 1.875"></polyline>
                                <path d="M7.12875,5.625 L7.12875,3.375" id="Path"></path>
                                <path d="M8.62875,0.375 L10.87875,0.375" id="Path"></path>
                                <polyline id="Path" points="7.12875 0.375 7.12875 1.875 8.62875 1.875"></polyline>
                                <path d="M1.87875,9.375 L4.12875,9.375" id="Path"></path>
                                <polyline id="Path" points="0.37875 8.625 0.37875 10.875 1.87875 10.875"></polyline>
                                <polyline id="Path" points="9.37875 17.625 16.12875 17.625 16.12875 12.375 17.62875 12.375 17.62875 14.625"></polyline>
                                <polyline id="Path" points="7.12875 13.125 7.12875 16.125 9.37875 16.125"></polyline>
                                <polyline id="Path" points="14.62875 16.125 10.87875 16.125 10.87875 14.25"></polyline>
                                <polyline id="Path" points="8.625 14.625 8.625 12.375 10.87875 12.375"></polyline>
                                <path d="M4.12875,10.875 L5.62875,10.875" id="Path"></path>
                                <path d="M9.75375,8.625 L8.25375,8.625" id="Path"></path>
                                <path d="M11.625,10.875 L13.875,10.875" id="Path"></path>
                                <path d="M13.125,10.875 L13.125,9.375" id="Path"></path>
                            </g>
                        </g>
                        <g id="Invisible_Shape">
                            <rect id="Rectangle" x="0" y="0" width="18" height="18"></rect>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
`;

export default photocode;
